import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

console.log("map-sectioncards.js");

document.addEventListener("DOMContentLoaded", () => {
    const mapContainer = document.getElementById("map");
    const mapWrapper = document.getElementById("sectioncardMap");

    if (!mapContainer) return;

    const accessToken = mapContainer.dataset.accessToken;
    if (!accessToken) return;

    mapboxgl.accessToken = accessToken;

    const cardElements = document.querySelectorAll(".card-item");
    const markers = [];

    cardElements.forEach(card => {
        const lat = parseFloat(card.dataset.lat);
        const lon = parseFloat(card.dataset.lon);
        const name = card.dataset.name;

        if (!isNaN(lat) && !isNaN(lon)) {
            markers.push({
                coords: [lon, lat],
                name: name,
            });
        }
    });

    if (markers.length === 0) {
        // Ocultar el mapa si no hay localizaciones
        if (mapWrapper) {
            mapWrapper.style.display = "none";
        }
        return;
    }

    const map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/streets-v11",
        center: markers[0].coords,
        zoom: 8,
    });

    markers.forEach(markerData => {
        const popup = new mapboxgl.Popup({ offset: 25 })
            .setHTML(`<strong>${markerData.name}</strong>`);

        const marker = new mapboxgl.Marker()
            .setLngLat(markerData.coords)
            .setPopup(popup)
            .addTo(map);

        marker.getElement().addEventListener("click", () => {
            popup.addTo(map);
            const targetCard = document.querySelector(`.card-item[data-name="${markerData.name}"]`);
            if (targetCard) {
                targetCard.scrollIntoView({ behavior: "smooth", block: "start" });
                targetCard.classList.add("highlight");
                setTimeout(() => targetCard.classList.remove("highlight"), 1500);
            }
        });
    });
});
